import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const initStickyObj = (args) => {
  const mm = gsap.matchMedia();

  mm.add({
    isDesktop: "(min-width: 1001px)",
    isMobile: "(max-width: 1000px)"
  }, (context) => {
    const { isDesktop } = context.conditions;

    let settings;
    // デフォルトは 0 を返す関数
    const defaultEndOffset = () => 0;

    if (typeof args === 'string') {
      settings = {
        trigger: args,
        target: `${args} .obj`,
        endOffset: defaultEndOffset
      };
    } else {
      const currentConfig = isDesktop ? args.pc : args.sp;
      settings = {
        ...currentConfig,
        // 設定が関数ならそのまま、数値なら関数に包む、なければ 0 を返す
        endOffset: typeof currentConfig.endOffset === 'function'
          ? currentConfig.endOffset
          : () => (currentConfig.endOffset || 0)
      };
    }

    const targetSec = document.querySelector(settings.trigger);
    const targetObj = document.querySelector(settings.target);

    if (!targetSec || !targetObj) return;

    const getCssFixedTop = () => {
      targetObj.classList.add('is-fixed');
      const fixedTop = parseFloat(window.getComputedStyle(targetObj).top);
      targetObj.classList.remove('is-fixed');
      return fixedTop || 0;
    };

    ScrollTrigger.create({
      trigger: targetSec,
      start: () => `top ${getCssFixedTop() - targetObj.offsetTop}px`,

      // 【修正ポイント】settings.endOffset() として実行することで最新の計算値を使う
      end: () => `bottom ${getCssFixedTop() + targetObj.offsetHeight + settings.endOffset()}px`,

      onEnter: () => {
        targetObj.classList.add('is-fixed');
        targetObj.classList.remove('is-absolute');
      },
      onLeave: () => {
        targetObj.classList.remove('is-fixed');
        targetObj.classList.add('is-absolute');
      },
      onEnterBack: () => {
        targetObj.classList.add('is-fixed');
        targetObj.classList.remove('is-absolute');
      },
      onLeaveBack: () => {
        targetObj.classList.remove('is-fixed');
        targetObj.classList.remove('is-absolute');
      },
      invalidateOnRefresh: true,
    });

    return () => {
      targetObj.classList.remove('is-fixed', 'is-absolute');
    };
  });
};

// 実行
window.addEventListener('DOMContentLoaded', () => {
  initStickyObj('.weddingfair-sec');
  initStickyObj('.feature-sec .inner');
  initStickyObj({
    pc: { trigger: '.ceremony-sec', target: '.ceremony-sec .obj' },
    sp: { trigger: '.ceremony-sec', target: '.ceremony-sec .obj' }
  });
  //initStickyObj('.ceremony-sec');
  initStickyObj('.banquet-sec');
  initStickyObj('.cuisine-sec');
  initStickyObj({
    pc: { trigger: '.feature-sec .inner', target: '.feature-sec .inner .obj' },
    sp: { trigger: '.feature-sec .inner', target: '.feature-sec .inner .obj' }
  });
});
const banquetSec = document.querySelector('.banquet-sec');
if (banquetSec) {
  const targetObj = banquetSec.querySelector('.obj');
  const photoEl = banquetSec.querySelector('.photo');
  const header = document.querySelector('header');

  if (targetObj && photoEl && header) {
    ScrollTrigger.create({
      trigger: photoEl,
      // .photo の上がヘッダーの下端に来た時
      start: () => `top ${header.offsetHeight}px`,
      // .photo が画面から消えるまで継続（必要に応じて調整）
      end: () => `bottom 0px`,

      onEnter: () => targetObj.classList.add('is-hide'),
      onLeave: () => targetObj.classList.remove('is-hide'),
      onEnterBack: () => targetObj.classList.add('is-hide'),
      onLeaveBack: () => targetObj.classList.remove('is-hide'),
    });
  }
}
